import React from 'react'
import { Picker } from 'emoji-mart'
import ClickOutHandler from 'react-onclickout'

import './styles.scss'
import { lang } from 'utils/helpers'

const EmojiSelector = props => {
  const { showEmojis, handleToggle, handleSelect, position = 'left' } = props

  return (
    <div className={`emoji-selector emoji-selector--${position}`}>
      {showEmojis ? (
        <ClickOutHandler onClickOut={handleToggle}>
          <Picker
            title={lang('dashboard_emojis')}
            i18n={{
              search: lang('dashboard_search'),
              clear: lang('dashboard_clean'),
              notfound: lang('emojiSelector_notFound'),
              skintext: lang('emojiSelector_skinToneText'),
              categories: {
                search: lang('dashboard_search-results'),
                recent: lang('dashboard_frequently-used'),
                people: lang('emojiSelector_emojis_people'),
                nature: lang('emojiSelector_animals_nature'),
                foods: lang('emojiSelector_food_drink'),
                activity: lang('dashboard_activity'),
                places: lang('emojiSelector_places'),
                objects: lang('dashboard_objects'),
                symbols: lang('dashboard_symbols'),
                flags: lang('dashboard_flags'),
                custom: lang('dashboard_personalized'),
              },
              categorieslabel: lang('emojiSelector_categorieslabel'),
              skintones: {
                1: lang('emojiSelector_skinToneDefault'),
                2: lang('emojiSelector_skinToneLight'),
                3: lang('emojiSelector_skinToneLightMedium'),
                4: lang('emojiSelector_skinToneMedium'),
                5: lang('emojiSelector_skinToneMediumDark'),
                6: lang('emojiSelector_skinToneDark'),
              }
            }}
            onClick={handleSelect}
          />
        </ClickOutHandler>
      ) : null}
    </div>
  )
}

export default EmojiSelector
